import { useEffect, useRef } from 'react';
import { useSipStore } from '../stores/sipStore';
import { useCustomerCard } from '../stores/customerCard';

/**
 * פותח את כרטיס הלקוח ברגע שנעשית שיחה פעילה — חיוג יוצא או נכנסת שנענתה.
 *
 * ממופתח לפי המספר, כך ששיחה חדשה פותחת מחדש; אם הנציג סגר, הכרטיס נשאר
 * סגור עד השיחה הבאה.
 *
 * חולץ מ-AgentLayout כדי שגם admin ו-superadmin יקבלו אותו — הסופטפון הצף
 * זמין בכל הפרסונות, אבל הכרטיס נפתח רק בפרסונת הסוכן, ובחיוג מקמפיין
 * הנציג נשאר בלי שום מידע על מי שענה.
 */
export function useCustomerCardPop(): void {
  const activeNumber = useSipStore((s) => s.active?.number ?? null);
  const lastPopped = useRef<string | null>(null);

  useEffect(() => {
    if (activeNumber && activeNumber !== lastPopped.current) {
      lastPopped.current = activeNumber;
      useCustomerCard.getState().show(activeNumber);
    }
    if (!activeNumber) lastPopped.current = null;
  }, [activeNumber]);

  // מוצא חירום מקיפאון ב-'wrap-up': כשהכרטיס פתוח, WrapupOverlay עומד מנגד
  // (`!cardOpen`) והכרטיס מארח את כפתור הסיום. אם הנציג סוגר את הכרטיס בזמן
  // הסיכום, אף רכיב לא קורא ל-finishWrapup — והסופטפון נשאר תקוע בלי דרך
  // לחייג שוב. כאן משחררים אותו: הסיכום כבר נשמר אוטומטית ע"י הכרטיס.
  const state = useSipStore((s) => s.state);
  const cardOpen = useCustomerCard((s) => s.open);
  const wasOpenInWrapup = useRef(false);

  useEffect(() => {
    if (state === 'wrap-up' && cardOpen) {
      wasOpenInWrapup.current = true;
      return;
    }
    if (state === 'wrap-up' && !cardOpen && wasOpenInWrapup.current) {
      wasOpenInWrapup.current = false;
      useSipStore.getState().finishWrapup();
    }
    if (state !== 'wrap-up') wasOpenInWrapup.current = false;
  }, [state, cardOpen]);
}
